import React from 'react';
import { Tag, Typography } from '@guildeducationinc/recess';
import styles from './CappedDateCta.module.scss';

export const CappedDateCta: React.FC = () => {
	return (
		<>
			<Typography gutterBottom='sm' testid='capped-date-cta' variant='label1'>
				This program is not currently accepting applications.
			</Typography>

			<div className={styles.cappedTag}>
				<Tag appearance='quiet' color='yellow'>
					Program is full
				</Tag>
			</div>
		</>
	);
};
